import { Cargo } from './cargo';

export class Funcoes {
    id:number;
	nome:string;
	cargo:Cargo;
	valorSalario:number;
	descricao:string;
	atribuicoes:string;
	conhecimentosEspecificos:string;
    comportamentosEsperados:string;
	qtdCargaHorariaMinima:number;
	qtdCargaHorariaMaxima:number;    
}

